module.exports = __webpack_public_path__ + "img/image9.4993c76d.png";